import { Product } from '../../types/product';
import { Category } from '../../types/category';

import { products } from '../../data/products';
import { categories } from '../../data/categories';

import { useCart } from '../../hooks/useCart';

import { ProductCard } from '../../components/ProductCard';

const productsByCategory = categories.reduce((productsHash, category) => {
  productsHash[category.type] = products.filter(
    product => product.enabled && product.category === category.type
  );

  return productsHash;
}, {} as Record<Category, Product[]>);

const buildProductCart = (product: Product) => ({
  name: product.name,
  price: product.price,
  description: product.description,
  category: product.category,
  countable: product.countable,
  quantity: 1,
});

export const ProductList = () => {
  const { addProduct, removeProduct, alreadyAdded } = useCart();

  const handleAddOrRemoveProduct = (product: Product) => {
    if (alreadyAdded(product)) {
      removeProduct(product);

      return;
    }

    addProduct(buildProductCart(product));
  };

  return (
    <>
      {categories.map(category => (
        <section
          key={`product-${category.type}-category`}
          className="mt-6 flex flex-col gap-2"
          id={`${category.type}-products-section`}
        >
          <h1 className="px-4 py-2 text-2xl font-bold text-red-600">{category.text}</h1>

          <div className="px-4 py-2 flex gap-4 overflow-x-auto">
            {productsByCategory[category.type].map((product, index) => (
              <ProductCard
                key={`product-item-${category.type}-${index}`}
                product={product}
                alreadyAdded={alreadyAdded(product)}
                onAction={handleAddOrRemoveProduct}
              />
            ))}
          </div>
        </section>
      ))}
    </>
  );
};
